<template>
    <div class="login-page">
      <!-- 错误提示 -->
      <div v-if="errorMessage" class="error-message">
        <i class="el-icon-warning"></i> {{ errorMessage }}
      </div>

      <!-- 登录背景 -->
      <login-background class="background-layer" />

      <!-- 导航栏 -->
    <!-- Navigation bar -->
    <nav class="main-nav">
      <a href="/">
        <div class="logo">
        <span class="logo-symbol"><img src="https://xtsq-oss-hb.oss-cn-beijing.aliyuncs.com/sunrise-images/sunrise-logo.png" width="60" height="60" alt="小晖智能客服" style="border-radius: 10%;"/></span>
        <span>小晖AI客服平台</span>
      </div>
      </a>
    </nav>

      <!-- 登录卡片 -->
      <div class="login-wrapper">
        <div class="login-card">

          <!-- 登录表单 -->
            <form @submit.prevent="handlePasswordLogin">
              <div class="form-group">
                <label for="username">用户名</label>
                <input
                  id="username"
                  v-model="loginForm.username"
                  type="text"
                  required
                  placeholder="请输入用户名"
                >
              </div>

              <div class="form-group">
                <label for="password">密&nbsp;&nbsp;码</label>
                <input
                  id="password"
                  v-model="loginForm.password"
                  type="password"
                  required
                  placeholder="请输入密码"
                >
              </div>

              <!-- 简化版图片验证码 -->
              <div class="form-group captcha-section">

                <div class="captcha-container">
                  <div v-if="captchaData && !captchaLoading" class="image-captcha">
                    <div class="captcha-question">{{ captchaData.question }}</div>
                    <div class="image-row">
                      <div
                        v-for="(image, index) in captchaData.images"
                        :key="index"
                        class="image-item"
                        :class="{ selected: selectedImage === index }"
                        @click="selectImage(index)"
                      >
                        <span class="image-emoji">{{ image }}</span>
                      </div>
                    </div>
                    <div class="captcha-actions">
                      <button type="button" class="refresh-captcha" @click="generateCaptcha">
                        <i class="el-icon-refresh"></i> 换一组
                      </button>
                    </div>
                  </div>
                  <div v-else class="loading-captcha">
                    <i class="el-icon-loading"></i> 加载验证码...
                  </div>
                </div>
              </div>
<input type="checkbox" id="checkbox1" v-model="agreement" value="Jack">              
  <label for="checkbox1">我已阅读并同意 </label><span class="link" @click="HandleLicense">小晖AI客服平台用户服务协议</span> 、 <span @click="HandleAcceptable" class="link">可接受使用政策</span>、<span @click="HandlePrivacy" class="link">隐私政策</span>和<span @click="HandleDataProtection" style="margin-right:30px;margin-left: 5px;" class="link">数据保护协议</span>
              <button type="submit" class="submit-btn" :disabled="!isCaptchaValid">
                <span v-if="!loading">登 录</span>
                <span v-else>
                  <i class="el-icon-loading"></i> 登录中...
                </span>
              </button>
            </form>
        <!-- 微信登录入口 -->
        <div class="wechat-login-section">
        </div>
            <div class="footer-links">
              <a href="/login">使用短信登录</a>
                        <button class="wechat-login-btn" @click="showWechatLogin">
            <i class="el-icon-chat-dot-round"></i>
            微信扫码登录
          </button>
              <a href="#" @click.prevent="showForgetPassword">忘记密码？</a>
            </div>
        </div>
      </div>
    <!-- 微信登录模态框 -->
    <WechatLogin 
      :visible="showWechatModal" 
      @update:visible="showWechatModal = $event"
      @login-success="handleWechatLoginSuccess"
    />

    <!-- 服务协议对话框 -->
      <el-dialog title="小晖AI客服平台用户服务协议" :visible.sync="open_licence" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="licenceContent"></div>
      </div>
    </el-dialog>
      <!-- 隐可接受使用策对话框 -->
      <el-dialog title="小晖AI客服平台可接受使用政策" :visible.sync="open_acceptable" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="acceptableContent"></div>
      </div>
    </el-dialog>

          <!-- 隐私政策对话框 -->
      <el-dialog title="小晖AI客服平台隐私政策" :visible.sync="open_privacy" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="privacyContent"></div>
      </div>
    </el-dialog>   
    

          <!-- 数据保护协议对话框 -->
      <el-dialog title="小晖AI客服平台数据保护协议" :visible.sync="open_data_protection" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="data_protectContent"></div>
      </div>
    </el-dialog>       
  </div>    
  </template>

  <script>
  import { mapActions } from 'vuex'
  import { Message } from 'element-ui'
  import LoginBackground from '@/components/LoginBackground.vue'
  import { getImageCaptcha } from '@/api/auth/login'
  import {getUserAgeement, getAcceptable, getPrivacy, getDataprotectionContent} from '@/api/tenant/agreement'
import WechatLogin from '@/components/WechatLogin.vue'
  export default {    
    components: {
      LoginBackground,   
      WechatLogin
    },
    data() {
      return {
        loginForm: {
          username: '',
          password: ''
        },
        captchaData: null,
        selectedImage: null,
        agreement: false,
        loading: false,
        captchaLoading: false,
        errorMessage: '',
        showWechatModal:false,

              // 用户服务协议
      open_licence: false,
      licenceContent: '-',
      // 可接受使用协议
      open_acceptable: false,
      acceptableContent: "-",
      // 隐私政策
      open_privacy: false,
      privacyContent: '-',
      // 数据协议
      open_data_protection: false,
      data_protectContent: '-',      
      }
    },
    computed: {
      isCaptchaValid() {
        return this.selectedImage !== null
      }
    },
    created() {
      this.generateCaptcha()
    },
    methods: {
      ...mapActions('auth', ['loginWithCaptcha']),

      // 生成图片验证码
      async generateCaptcha() {
        try {
          this.captchaLoading = true
          this.selectedImage = null
          const response = await getImageCaptcha()
          console.log(response);
          this.captchaData = response.data.data;
          console.log('验证码数据:', this.captchaData)
        } catch (error) {
          console.error('生成验证码失败:', error)
          this.showError('验证码加载失败，请刷新页面重试')
        } finally {
          this.captchaLoading = false
        }
      },

      // 选择图片（单选）
      selectImage(index) {
        this.selectedImage = index
      },

    HandleLicense() {
      this.open_licence = true;
      this.licenceContent =getUserAgeement();
    },
    HandleAcceptable(){
      this.open_acceptable = true
      this.acceptableContent = getAcceptable();
    },
    //隐私政策对话框
     HandlePrivacy() {
       this.open_acceptable = false
       this.open_data_protection = false
        this.open_privacy = true;
        this.privacyContent = getPrivacy();
    },   
        //数据保护协议对话框
     HandleDataProtection() {
        this.open_acceptable = false
        this.open_privacy = false;
               this.open_data_protection = true;
        this.data_protectContent = getDataprotectionContent();        
    },    
      async handlePasswordLogin() {    
        if(!this.agreement)  {
          this.showError('请请阅读并同意《小晖AI客服平台用户服务协议》、《可接受使用政策》、《隐私政策》、《数据保护协议》')
          return          
        }
        if (!this.isCaptchaValid) {
          this.showError('请完成安全验证')
          return
        }

        this.loading = true
        try {
          console.log("开始登录..")
          const result = await this.loginWithCaptcha({
            credentials: {
              username: this.loginForm.username,
              password: this.loginForm.password
            },
            captchaId: this.captchaData.captchaId,
            captchaAnswer: this.selectedImage
          })
          
          console.log("完整的登录结果:", result)
          console.log("result.data:", result.data)
          console.log("token字段:", result.token || result.data?.token)
          console.log("所有字段:", Object.keys(result))
          
          if (result && result.success) {
            // 直接跳转，不调用handleLoginSuccess
            if (result.tenantUserInfo != null && result.employeeUserInfo == null && result.tenantUserInfo.status !=null
                && (result.tenantUserInfo.status == 'APPROVED' || result.tenantUserInfo.status.trim() =='DELETED')) {
              this.$router.push('/admin/main')
            } else if (result.tenantUserInfo != null && result.employeeUserInfo != null) {
              this.$router.push('/employee/workspace')
            } else if ((result.tenantUserInfo == null || result.tenantUserInfo.status !== 'APPROVED') 
                      && result.employeeUserInfo == null) {
              this.$router.push('/raw_user/home')
            }
          } else {
            Message.warning(result.message || '登录失败')
            this.generateCaptcha()
          }
        } catch (error) {
          this.showError('登录失败: ' + (error.message || '请检查网络连接'))
          console.error('登录错误详情:', error)
          this.generateCaptcha()
        } finally {
          this.loading = false
        }
      },
      handleWechatLoginSuccess(result) {
        this.handleLoginSuccess(result)
      },      
      async handleLoginSuccess(result) {
          console.log("handleLoginSuccess", result)
          if(result == undefined){
            this.showError('登录失败')
            return
          }
          
          // 移除setTimeout，直接跳转
          if (result.tenantUserInfo != null && result.tenantUserInfo != undefined && 
              (result.employeeUserInfo == null || result.tenantUserInfo != undefined)
              && result.tenantUserInfo.status == 'APPROVED') {
            this.$router.push('/admin/main')
          } else if (result.tenantUserInfo != null && result.employeeUserInfo != null) {
            this.$router.push('/employee/workspace')
          } else if ((result.tenantUserInfo == null || result.tenantUserInfo.status !== 'APPROVED') 
                    && result.employeeUserInfo == null) {
            this.$router.push('raw_user/home')
          }
        },

      showError(message) {
        this.errorMessage = message
        setTimeout(() => {
          this.errorMessage = ''
        }, 3000)
      },

      showForgetPassword() {
        this.showError('请使用短信登录后修改密码')
      },
      showWechatLogin() {
        this.showWechatModal = true
      },
    }
  }
  </script>

  <style scoped lang="scss">
  @import '@/styles/variables.scss';
  @import '@/styles/public-theme1.scss';

  .login-page {
    min-height: 100vh;
    position: relative;
    background: $light-bg;

    .background-layer {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    .main-nav {
      position: relative;
      padding: 24px 5%;
      background: rgba($space-blue, 0.9);
      z-index: 1;

      .logo {
        display: flex;
        align-items: center;
        color: white;
        font-size: 1.4rem;
        font-weight: 600;

        .logo-symbol {
          color: $electric-blue;
          font-size: 2rem;
          margin-right: 12px;
        }
      }
    }

    .login-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: calc(100vh - 92px);
      padding: 40px 20px;
      z-index: 1;
    }

    .login-card {
      width: 100%;
      max-width: 480px; /* 稍微缩小卡片宽度 */
      background: white;
      border-radius: 16px;
      box-shadow: 0 12px 48px rgba($space-blue, 0.15);
      padding: 40px;
    }

    .captcha-section {
      margin-bottom: 24px;

      .captcha-container {
        width: 100%;

      }

      .image-captcha {
        border: 1px solid $gray-border;
        border-radius: 10px;
        padding: 6px;
        background: #fafafa;
      }

      .captcha-question {
        font-size: 0.8rem;
        font-weight: 400;
        color: $space-blue;
        margin-bottom: 6px;
        text-align: center;
      }

      .image-row {
        display: flex;
        justify-content: space-between;
        gap: 8px;
        margin-bottom: 12px;
      }

      .image-item {
        flex: 1;
        aspect-ratio: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid $gray-border;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;
        background: white;
        min-height: 50px;

        &:hover {
          border-color: $electric-blue;
          transform: translateY(-2px);
        }

        &.selected {
          border-color: $electric-blue;
          background: rgba($electric-blue, 0.1);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba($electric-blue, 0.2);
        }

        .image-emoji {
          font-size: 1.8rem;
        }
      }

      .captcha-actions {
        text-align: center;
        padding-top: 8px;
      }

      .refresh-captcha {
        background: none;
        border: none;
        color: $electric-blue;
        cursor: pointer;
        font-size: 0.8rem;
        transition: color 0.3s;


        &:hover {
          color: darken($electric-blue, 10%);
          background: rgba($electric-blue, 0.05);
          border-radius: 4px;
        }

        i {
          margin-right: 4px;
        }
      }

      .loading-captcha {
        text-align: center;
        padding: 30px;
        color: $space-blue;
        font-size: 0.9rem;
      }
    }

    .form-group {
      margin-bottom: 24px;
      display: flex;

      label {
        display: inline-block;
        margin: 5px 5px 10px 8px 5px;
        padding-top: 10px;
        font-size: 0.8rem;
        color: #474747;
        font-weight: 500;
        width: 120px;
      }

      input {
        width: 80%;
        padding: 12px 16px;
        border: 1px solid $gray-border;
        margin-left: 20px;
        border-radius: 8px;
        font-size: 0.8rem;
        transition: all 0.3s;

        &:focus {
          border-color: $electric-blue;
          box-shadow: 0 0 0 3px rgba($electric-blue, 0.15);
        }
      }
    }

    .submit-btn {
      width: 100%;
      padding: 14px;
      margin: 24px 0 20px;
      background: $electric-blue;
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 1.1rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba($electric-blue, 0.3);
      }

      &:disabled {
        background: #ccc;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
      }
    }

    .footer-links {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;

      a {
        color: lighten($space-blue, 20%);
        font-size: 0.9rem;
        text-decoration: none;
        transition: color 0.3s;
        padding: 4px 0;

        &:hover {
          color: $electric-blue;
          text-decoration: underline;
        }
      }

      .register-link {
        font-weight: 600;
        color: $electric-blue;
      }
    }

    .error-message {
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 40000;
      padding: 12px 24px;
      background: #fff6f6;
      color: #f56c6c;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      display: flex;
      align-items: center;
    }

    .error-message i {
      margin-right: 8px;
    }
  }

  @media (max-width: 768px) {
    .login-card {
      padding: 32px 24px !important;
      margin: 0 16px;
    }

    .captcha-section .image-item .image-emoji {
      font-size: 1.5rem;
    }

    .image-row {
      gap: 6px !important;
    }
  }

  @media (max-width: 480px) {
    .captcha-section .image-item {
      min-height: 40px;
      
      .image-emoji {
        font-size: 1.3rem;
      }
    }
  }
  .wechat-login-btn{
    background-color:  white;
    border: 0;
  }

  .link {
  color: $electric-blue;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
}

/* checkbox 样式 - 只保留一份 */
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 26px;
  height: 26px;
  border: 2px solid $electric-blue;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s;
  flex-shrink: 0;
}

input[type="checkbox"]:checked {
  background-color: $electric-blue;
  border-color: $electric-blue;
}

input[type="checkbox"]:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 18px;
  font-weight: bold;
}

input[type="checkbox"]:hover {
  border-color: darken($electric-blue, 10%);
}

  </style>